export default __webpack_public_path__ + "1daffdcc0521f7393e1c3de04676b947.png";